export default __webpack_public_path__ + "static/lote_2-fbd5a2203fd17332fde8425b2e7b84c2.png";